<!-- prettier-ignore -->
<header class="top-bar">
  <div class="left-section">
    @if (title.url) {
      <a [routerLink]="title.url" class="title-link"> {{ title.text }} </a>
    } @else {
      <h1 class="title">{{ title.text }}</h1>
    }
  </div>

  <!-- prettier-ignore -->
  <div class="right-section">
    @for (item of items; track item.name ?? $index) {
      @if (item.action) {
        <button type="button" class="info-item clickable" (click)="item.action()">
          <app-icon [name]="item.name" [ariaLabel]="item.text" />
          <span>{{ item.text }}</span>
        </button>
      } @else {
        <div class="info-item">
          <app-icon [name]="item.name" [ariaLabel]="item.text" />
          <span>{{ item.text }}</span>
        </div>
      }
    }
  </div>
</header>
